import { Component, inject, Injector, Input } from '@angular/core';
import { Patient } from '../models/patient';
import { TuiCardLarge, TuiHeader } from '@taiga-ui/layout';
import { PatientTitleGroupComponent } from '../patient-title-group/patient-title-group.component';
import { DatePipe } from '@angular/common';
import {
  TuiButton,
  TuiDialogService,
  TuiIcon,
  TuiSurface,
} from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { DemandeContactModalComponent } from '../demande-contact/demande-contact-modal/demande-contact-modal.component';

@Component({
  selector: 'app-infos-patient-card',
  standalone: true,
  imports: [
    TuiHeader,
    TuiCardLarge,
    TuiSurface,
    PatientTitleGroupComponent,
    DatePipe,
    TuiIcon,
    TuiButton
  ],
  templateUrl: './infos-patient-card.component.html',
  styleUrl: './infos-patient-card.component.scss',
})
export class InfosPatientCardComponent {
  @Input() patient: Patient | undefined;
  @Input() enCoursDeChargement: boolean = false;
  @Input() activite?: string;

  private readonly dialogService = inject(TuiDialogService);
  private injector = inject(Injector);

  openDialog(): void {
    // Create a custom injector to pass the data to the modal
    const dialogInjector = Injector.create({
      providers: [
        {
          provide: 'patient', // You will inject this in the modal component
          useValue: this.patient,
        },
      ],
      parent: this.injector,
    });

    this.dialogService
      .open(
        new PolymorpheusComponent(DemandeContactModalComponent, dialogInjector),
      )
      .subscribe();
  }

  imprimer(): void {
    window.print();
  }

}
